var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.view == 'DECKS')?_c('view-cards',{on:{"JoinGame":_vm.JoinGame}}):_vm._e(),(_vm.view == 'ARENA')?_c('arena',{attrs:{"gameData":_vm.gameData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }